import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
import get from 'lodash/get';
import addYears from 'date-fns/addYears';
import addDays from 'date-fns/addDays';
var NEUTRAL_DAYS = 90; // С августа 2021 дается 90 дневный период на замену паспорта

var START_PASSPORT_ISSUING = new Date(1997, 9, 1); // Начало выдачи паспортов РФ

var passportIssueDate = function passportIssueDate(_a) {
  var birthDatePath = _a.birthDatePath,
    _b = _a.messageBeforeFourteen,
    messageBeforeFourteen = _b === void 0 ? 'Не ранее 14 лет с даты рождения' : _b,
    _c = _a.messageBeforeFirstIssue,
    messageBeforeFirstIssue = _c === void 0 ? 'Не ранее 1 октября 1997 года' : _c,
    _d = _a.messageAfterCurrentDate,
    messageAfterCurrentDate = _d === void 0 ? 'Не позднее текущей даты' : _d,
    _e = _a.messageOldPassport,
    messageOldPassport = _e === void 0 ? 'Паспорт недействителен' : _e;
  return function (issueDate, allValues) {
    var currentDate = new Date();
    var birthDate = get(allValues, birthDatePath);
    if (!issueDate || !birthDate) {
      return;
    }
    if (isBefore(issueDate, START_PASSPORT_ISSUING)) {
      return messageBeforeFirstIssue;
    }
    if (isAfter(issueDate, currentDate)) {
      return messageAfterCurrentDate;
    }
    var fourteenYears = addYears(birthDate, 14);
    var twentyYears = addYears(birthDate, 20);
    var fortyFiveYears = addYears(birthDate, 45);
    if (isBefore(issueDate, fourteenYears)) {
      return messageBeforeFourteen;
    }
    if (isAfter(currentDate, addDays(twentyYears, NEUTRAL_DAYS)) && isBefore(issueDate, twentyYears) || isAfter(currentDate, addDays(fortyFiveYears, NEUTRAL_DAYS)) && isBefore(issueDate, fortyFiveYears)) {
      return messageOldPassport;
    }
    return;
  };
};
export { passportIssueDate };